import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import './noAccess.css'

@autobind
class WorkNoAccess extends Component {
  render () {
    return (
      <div styleName='container' className='workMedia'>
        <img styleName='image' src='/images/search/no-access.png' alt='WorkView no access' />
        <p>It appears you can’t access this work.</p>
        <p>Fortunately, we have a lot more work to discover!</p>

        <a styleName='backBtn' className='btn btn-block btn-primary' href='/'>Search another piece of writing</a>
      </div>
    )
  }
}

export default WorkNoAccess

WorkNoAccess.propTypes = {
  onBack: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/work/noAccess.js